export enum RecruitmentActionType {
	NEW_APPLICATION = "NEW_APPLICATION",
	INTERVIEW_1 = "INTERVIEW_1",
	INTERVIEW_2 = "INTERVIEW_2",
	// NOT_CURRENT = "NOT_CURRENT",
	// PROFILE_APPROVED = "PROFILE_APPROVED",
	// TELEPHONE_INTERVIEW = "TELEPHONE_INTERVIEW",
	// TEST = "TEST",
	REFERENCE_TAKING = "REFERENCE_TAKING",
	REFERENCE_TAKING_AND_CHARGE_REGISTER = "REFERENCE_TAKING_AND_CHARGE_REGISTER",
	CHARGE_REGISTER = "CHARGE_REGISTER",
	INTRODUCTION = "INTRODUCTION",
	WAGE_SETTING = "WAGE_SETTING",
	CANDIDATE_GETS_BACK = "CANDIDATE_GETS_BACK",
	NO_THANKS = "NO_THANKS",
	// CANDIDATE_DECLINED = "CANDIDATE_DECLINED",
	// NO_THANKS_SENT = "NO_THANKS_SENT",
	AGREEMENT_SENT = "AGREEMENT_SENT",
	AGREEMENT_SIGNED = "AGREEMENT_SIGNED",
	AGREEMENT_EXPIRED = "AGREEMENT_EXPIRED",
	AGREEMENT_RECALLED = "AGREEMENT_RECALLED",
}
